export default __webpack_public_path__ + "static/bg-girl-thermometer-mobile-7f729719dbc2ae2fbf4336a2b6ef118c.jpg";